import { type FigureInfoKey, figureInfoKeyLabelI18nKeyMap } from '../figureInfo'

// 翻訳値から i18n キーへのマッピング（既存データの互換性のため）
// 重複する翻訳値は旧共有キーにマッピング
// prettier-ignore
const NAME_TO_I18N_KEY_MAP: Record<string, string> = {
  // brand
  'ブランド': 'brand_type',
  'Brand Name': 'brand_type',
  // brandGroup
  'ブランドグループ': 'brand_group',
  'Brand Group': 'brand_group',
  // columnCustomerAttributes
  '顧客属性 (列方向)': 'customized_segments_column',
  'Customized Segments (Column)': 'customized_segments_column',
  // creator
  '作成者': 'owner',
  'Owner': 'owner',
  // customerAttributes
  '顧客属性': 'customized_segments',
  'Custom Segment': 'customized_segments',
  // dataDisplayType
  'データ表示形式': 'data_display_format',
  'Data Display': 'data_display_format',
  // figureType
  '図表の種類': 'chart_type',
  'Chart Type': 'chart_type',
  // groupFilters, overlapGroupFilters（重複 → 旧共有キー）
  'グループの指定': 'select_group',
  'Group Selection': 'select_group',
  'Select Group': 'select_group',
  // isValueAxisMaxStandardized
  'グラフの最大値を統一': 'fix_yaxis',
  'Lock Y-axis': 'fix_yaxis',
  // overlapBrand1
  '比較ブランド1': 'compare_brand_1',
  'Brand 1': 'compare_brand_1',
  // overlapBrand2
  '比較ブランド2': 'compare_brand_2',
  'Brand 2': 'compare_brand_2',
  // questions
  '設問名': 'questionnaire',
  'Survey Question': 'questionnaire',
  // resultViewerType, tableChartType（重複 → 旧共有キー）
  '表・グラフ表示形式': 'tablegraph_format',
  'Table or Graph Format': 'tablegraph_format',
  // screenLabel
  '分析機能': 'analysis_function',
  'Analysis Type': 'analysis_function',
  // segmentDisplayType
  'セグメント表示形式': 'segment_format',
  'Segment Format': 'segment_format',
  // survey
  'サーベイ': 'survey',
  'Survey': 'survey',
  // surveyFilter, surveyGroupFilter（重複 → 旧共有キー）
  '絞り込み': 'filter',
  'Filter': 'filter',
  // surveyGroup
  'サーベイグループ': 'survey_group',
  'Survey Group': 'survey_group',
}

// 新キー → 旧キーのマッピング（重複があったもののみ）
const NEW_TO_OLD_KEY_MAP: Record<string, string> = {
  filter_survey: 'filter',
  filter_survey_group: 'filter',
  select_group_overlap: 'select_group',
  tablegraph_format_result_viewer: 'tablegraph_format',
  tablegraph_format_table_chart: 'tablegraph_format',
}

/**
 * 翻訳値を i18n キーに変換します。
 * 既存データの互換性のため、翻訳値（日本語/英語）を旧共有キーにマッピングします。
 *
 * @param name - メタデータの name（翻訳値または i18n キー）
 * @returns 正規化された i18n キー
 */
export function resolveToEnglishKey(name: string): string {
  return NAME_TO_I18N_KEY_MAP[name] ?? name
}

/**
 * figureInfoKey から旧共有キーを取得します。
 * 新キーが旧キーにマッピングされている場合は旧キーを返し、
 * そうでない場合は新キーをそのまま返します。
 *
 * @param figureInfoKey - FigureInfoKey
 * @returns 旧共有キー（または新キー）
 */
export function getOldKeyForFigureInfoKey(
  figureInfoKey: FigureInfoKey,
): string {
  const newKey = figureInfoKeyLabelI18nKeyMap[figureInfoKey]

  return NEW_TO_OLD_KEY_MAP[newKey] ?? newKey
}
